import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from '../dropdown/dropdown.module';
import { VersionMenuComponent } from './version-menu.component';
import { OrderModule } from 'ngx-order-pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ActionMenuDirective } from '../action-menu/action-menu.directive';
import { ActionMenuComponent } from '../action-menu/action-menu.component';

@NgModule({
  imports: [CommonModule, OrderModule, DropdownModule, TranslateModule, ActionMenuDirective, ActionMenuComponent],
  exports: [VersionMenuComponent],
  declarations: [VersionMenuComponent],
})
export class VersionMenuModule {}
